/* eslint-disable react/forbid-component-props */
import React, { useState, useEffect } from 'react'
import { Container, Typography, Box, LinearProgress } from '@mui/material'
import { Link as NavigateLink, Link } from 'react-router-dom'
import GuideLayout from './GuideLayout'
import { useAuth } from '../../../contexts/AuthContext'
import DogLawUK from './Pages/DogLawUK'

const DogLaw = () => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const { currentUser } = useAuth()

  useEffect(() => {
    setUser(currentUser)
    setLoading(false)
  }, [currentUser])

  return (
    <section>
      <Container fixed sx={{ marginTop: '50px' }}>
        <Typography mb={6} variant="h4">
          Training Guide
        </Typography>
        <NavigateLink to="/members">{'< Back to Members Area'}</NavigateLink>
        <Box sx={{ marginTop: 5 }}>
          {!!loading && <LinearProgress color="primary" />}
          <GuideLayout
            watermark={`Licensed to ${user?.firstName} ${user?.lastName}`}
          >
            <Box>
              <Typography align="center" mb={3}>
                PADs In Training Guide
              </Typography>
              <Typography variant="h4" align="center" mb={3}>
                Table of Contents
              </Typography>

              <Box
                component="ul"
                sx={{ pl: 3, listStyle: 'none', p: 0, m: 0, mb: 5 }}
              >
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#dog-law">7. UK Dog Law</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#dogs-road">
                    Laws on driving with dogs and road accidents
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#dogs-public">
                    Laws on walking with your dog in public places
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#dogs-others">
                    Laws on keeping others safe around your dog
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#stray">
                    Laws on stray dogs, breeding and buying puppies
                  </a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#microchip">Microchipping and dog tags, UK law</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#access-rights">Public Access Rights</a>
                </li>
              </Box>
            </Box>
            <DogLawUK />
          </GuideLayout>
        </Box>
      </Container>
    </section>
  )
}

export default DogLaw
